import {Box, Grid} from '@material-ui/core'
import ReportsDensity from 'modules/reports/components/Density'
import ReportsIndexFilters from 'modules/reports/components/Index/Filters'
import ReportsSearch from 'modules/reports/components/Search'
import React from 'react'
import useStyles from './ReportsIndexPanel.styles'

function ReportsIndexPanel() {
  const classes = useStyles()

  return (
    <Box className={classes.root} paddingX={4} paddingY={0.5}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        component="header"
      >
        <Grid item>
          <Grid container direction="row" spacing={2}>
            <ReportsSearch />
            <ReportsIndexFilters />
          </Grid>
        </Grid>

        <Grid item>
          <ReportsDensity />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ReportsIndexPanel
